export default __webpack_public_path__ + "static/SR France - Fiche de Données Sécurité - Caramel colorant (Poudre)-626dabc98d2cf7b6cafff6920d7c2522.pdf";